export var EVENT_NAME = 'account_menu';
export var EVENT_NAME_LOGOUT = 'logout';